import Script from 'next/script'

function CookieBot() {
  return (
    <Script
      strategy='worker'
      id='Cookiebot'
      src='https://consent.cookiebot.com/uc.js'
      data-cbid='08e49875-6c87-454b-80ce-28d5b5cf7b17'
      data-blockingmode='auto'
      type='text/javascript'
    />
  )
}

export default CookieBot
